export default __webpack_public_path__ + "BG-8762973ff2f359d5416c7a9217543642.jpg";